var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vendor-allocated-table" },
    [
      _c("vue-good-table", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          rows: _vm.orders,
          "sort-options": {
            enabled: true,
            initialSortBy: { field: "allocatedId", type: "desc" }
          },
          "search-options": {
            enabled: true,
            trigger: "enter",
            skipDiacritics: true,
            placeholder: "Search this table"
          },
          "pagination-options": {
            enabled: true,
            mode: "pages",
            perPage: 10
          }
        },
        on: { "on-row-click": _vm.onRowClick }
      }),
      _vm._v(" "),
      _c(
        "vue-modality",
        {
          ref: "poNumModal",
          attrs: { title: _vm.modal.title, centered: "" },
          on: {
            ok: _vm.updatePO,
            cancel: function($event) {
              return _vm.$refs.poNumModal.hide()
            }
          }
        },
        [
          _c(
            "form",
            {
              attrs: { method: "post", "accept-charset": "UTF-8", action: "" }
            },
            [
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "po_number" }
                },
                [_vm._v("PO Number")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedPO,
                    expression: "selectedPO"
                  }
                ],
                staticClass: "form-input block w-full sm:text-sm sm:leading-5",
                attrs: { type: "text", name: "po_number", required: "" },
                domProps: { value: _vm.selectedPO },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.selectedPO = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "poDate" }
                },
                [_vm._v("PO Date for Delivery")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedPoDate,
                      expression: "selectedPoDate"
                    }
                  ],
                  staticClass:
                    "form-input block w-full sm:text-sm sm:leading-5",
                  attrs: {
                    type: "date",
                    "value-type": "YYYY-MM-DD",
                    format: "MM/DD/YYYY",
                    name: "poDate"
                  },
                  domProps: { value: _vm.selectedPoDate },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.selectedPoDate = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "block text-sm font-medium leading-5 text-gray-700",
                  attrs: { for: "anticipatedDD" }
                },
                [_vm._v("Estimated Date for Delivery")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.anticipatedDD,
                      expression: "anticipatedDD"
                    }
                  ],
                  staticClass:
                    "form-input block w-full sm:text-sm sm:leading-5",
                  attrs: {
                    type: "date",
                    "value-type": "YYYY-MM-DD",
                    format: "MM/DD/YYYY",
                    name: "anticipatedDD",
                    disabled: ""
                  },
                  domProps: { value: _vm.anticipatedDD },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.anticipatedDD = $event.target.value
                    }
                  }
                })
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }